

export interface AvailableBox {
    size: string;
    number: number;
}

export interface OccupiedBox {
    size: string;
    number: number;
}

export interface Schedule {
    day: number;
    openingHour: string;
    closingHour: string;
}

export interface Locker {
    name: string;
    country: string;
    countryId: number;
    county: string;
    countyId: number;
    city: string;
    cityId: number;
    address: string;
    postalCode: string;
    lat: number;
    lng: number;
    lockerId: number;
    supportedPayment: number;
    clientVisible: number;
    deliveryLogisticLocation: string;
    email: string;
    phone: string;
    excludedSellers: any[];
    availableBoxes: AvailableBox[];
    reservedBoxes: any[];
    occupiedBoxes: OccupiedBox[];
    schedule: Schedule[];
    cityHighlight: WordHighlightRange;
    countyHighlight: WordHighlightRange;
    addressHighlight: WordHighlightRange;
    nameHighlight: WordHighlightRange;
}

export interface LocalStorageFavouriteLocker {
    lockerId: number;
    lat: number;
    lng: number;
    type: FavouriteLockerType
}

export interface FavouriteLocker {
    type: FavouriteLockerType;
    mapCenterOrder: number;
    icon: string;
}

export interface PreviouslyUsedLocker {
    lockerId: number;
    lat: number;
    lng: number;
    dateClicked: Date;
}

export interface ScheduleInterval {
    startDay: number;
    endDay: number;
    openingHour: string;
    closingHour: string;
}

export interface LockerPluginOptions {
    countryCode: string;
    langCode: string;
    clientId: string;
    county: string;
    city: string;
    favLockerId: number;
    theme: string;
    apiUsername?: string;
    filters?: any[];
}

export interface PointLocation {
    lat: number;
    lng: number;
}

export interface LockerResponse {
    count: number;
    data: Locker[];
}

export interface PostMessage {
    subscription: SubscriptionType,
    object: any
}

export interface FavouriteLockerOrderType{
    favouriteLockerType: FavouriteLockerType,
    order: number,
}

export interface GenericNode<T> {
    properties: T;
    children: React.ReactNode;
};

export interface WordHighlightRange {
    startIndex: number,
    endIndex: number;
}

export interface CollapseProperties {
    componentId: string,
    textShowButton: string,
    textHideButton: string
}

export enum SubscriptionType {
    SelectLocker = 'SelectLocker',
    FavouriteLocker = 'FavouriteLocker'
}

export enum FavouriteLockerIntegratorOption {
    Unknown,
    Disabled,
    Enabled
}

export enum FavouriteLockerType {
    Unknown = 0,
    Home = 1,
    Work = 2
}

export enum CountryCode {
    Romania = "RO",
    Hungary = "HU",
    Bulgaria = "BG"
}
